import SelectLoader, {LoaderFn} from "@/lib/components/VSelectV2/SelectLoader";
import DataGridLoader, {ServiceMethod} from "@/lib/components/VDataGridV2/DataGridLoader";
import Core           from "@/core/Core";
import PersonsService from "@/domains/Persons/PersonsService";
import PartnersService from "@/domains/Partners/PartnersService";

/**
 * Фабрика лоадеров данных.
 *
 * @example
 * Loader.select<Order>(({ seller }) => StoresService.getList({ partnerId: seller.id }))
 *   .dependsOn({ seller: () => this.localOrder.seller })
 *   .preloadOnFocus()
 *
 * @example
 * Loader.dataGrid(TendersService.getListPaginated)
 *   .useExtraParams({ isDeleted:false} )
 *   .useReactiveSource(() => ({ tabId: this.tabId }))
 */
export default class Loader {

  /** Источник опций для VSelect. */
  static select<T = any>(dataSource: LoaderFn<T> | any[]): SelectLoader<T> {
    return new SelectLoader<T>(dataSource);
  }

  /** Источник данных для VDataGridV2. */
  static dataGrid<TParams = any, TEntity = any>(serviceMethod: ServiceMethod<TParams, TEntity>): DataGridLoader<TParams, TEntity> {
    return new DataGridLoader<TParams, TEntity>(serviceMethod);
  }

  // ==================== Целевые лоадеры ====================

  /**
   * Сотрудники текущего партнёра — источник для полей «Ответственный».
   * Значение по умолчанию (текущего пользователя) ставит модель, поэтому
   * заранее грузить нечего — сотрудники ищутся на сервере по вводу.
   */
  static responsible(): SelectLoader {
    return new SelectLoader(({ pattern }) => PersonsService.searchPersons(pattern, Core.currentPartner.id));
  }

  /** Поставщики — поиск по имени партнёра и именам его юр. лиц. */
  static sellers(): SelectLoader {
    return new SelectLoader(({ pattern }) => PartnersService.searchSellers(pattern));
  }

  /** Покупатели — поиск по имени партнёра и именам его юр. лиц. */
  static buyers(): SelectLoader {
    return new SelectLoader(({ pattern }) => PartnersService.searchBuyers(pattern));
  }
}
